import TailwindButton from "components/general/tailwindButton";

const AdditionalFeatures = () => {
  return (
    <div className="flex flex-col justify-center items-end w-full mt-10">
      <div className="flex justify-center items-end w-full mt-10">
        <div className="absolute w-[1228px] bg-slate-500 h-[1px] -z-10 opacity-25" />
        <div className="absolute w-[280px]  bg-brand-gray900 h-[1px] -z-10" />
      </div>
      <div className="flex justify-center items-end w-full -mt-7">
        <p className="font-bold text-[14px] bg-gradient-to-r from-brand-purple to-brand-blue text-transparent bg-clip-text">
          A D D I T I O N A L &nbsp; F E A T U R E S
        </p>
      </div>
      <div className="flex flex-col justify-center items-center w-full">
        <div className="flex w-[1228px] h-[76px]">
          <p className="px-5 mt-5 w-[483px] text-[16px]">
            Browser scan - automatically find and link your account to Redact
          </p>
          <div className="px-14 mt-7 w-[161px]">
            <span
              className="icon-[ic--sharp-check]"
              style={{ width: "2rem", height: "2rem" }}
            ></span>
          </div>
          <div className="px-[10.5rem] mt-7 w-[161px]">
            <span
              className="icon-[ic--sharp-check]"
              style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
            ></span>
          </div>
          <div className="ml-28 mt-7 w-[161px]">
            <span
              className="icon-[ic--sharp-check]"
              style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
            ></span>
          </div>
        </div>
        <div className="flex w-[1228px] h-[56px] bg-brand-slate">
          <p className="px-5 w-[483px] justify-center items- text-[16px] ">
            Desktop and mobile version included
          </p>
          <div className="px-14 mt-5 w-[161px]">
            <span
              className="icon-[ic--sharp-check]"
              style={{ width: "2rem", height: "2rem" }}
            ></span>
          </div>
          <div className="px-[10.5rem] mt-5 w-[161px]">
            <span
              className="icon-[ic--sharp-check]"
              style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
            ></span>
          </div>
          <div className="ml-28 mt-5 w-[161px]">
            <span
              className="icon-[ic--sharp-check]"
              style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
            ></span>
          </div>
        </div>
        <div className="flex w-[1228px] h-[56px] ">
          <p className="px-5 w-[483px] justify-center items- text-[16px] ">Priority Support</p>
          <div className="px-14 justify-center w-[161px]">
            <p className="text-slate-300 opacity-75">Limited</p>
          </div>
          <div className="px-[10.5rem] mt-4 w-[161px]">
            <span
              className="icon-[ic--sharp-check]"
              style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
            ></span>
          </div>
          <div className="ml-28 mt-4 w-[161px]">
            <span
              className="icon-[ic--sharp-check]"
              style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
            ></span>
          </div>
        </div>
        <div className="flex w-[1228px] h-[56px] bg-brand-slate">
          <p className="px-5 w-[483px] justify-center  text-[16px] ">
            Built in archiver to save deleted content to your device
          </p>
          <div className="px-14 justify-center w-[161px]">
            <p className="text-slate-300 opacity-75">Limited</p>
          </div>
          <div className="px-[10.5rem] justify-center w-[161px]">
            <p className="text-slate-300 opacity-75">Limited</p>
          </div>
          <div className="ml-28 mt-5 w-[161px]">
            <span
              className="icon-[ic--sharp-check]"
              style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
            ></span>
          </div>
        </div>
        <div className="flex w-[1228px] h-[56px] ">
          <p className="px-5 w-[483px] justify-center text-[16px] ">
            Schedule and automate regular deletions
          </p>
          <div className="px-14 mt-5 w-[161px]">
            <span
              className="icon-[system-uicons--cross]"
              style={{ width: "2rem", height: "2rem" }}
            ></span>
          </div>
          <div className="px-[10.5rem] mt-5 w-[161px]">
            <span
              className="icon-[ic--sharp-check]"
              style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
            ></span>
          </div>
          <div className="ml-28 mt-5 w-[161px]">
            <span
              className="icon-[ic--sharp-check]"
              style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
            ></span>
          </div>
        </div>
        <div className="flex w-[1228px] h-[56px] bg-brand-slate">
          <p className="px-5 w-[483px] justify-center items- text-[16px] ">Multi-account support</p>
          <div className="px-14 mt-5 w-[161px]">
            <span
              className="icon-[system-uicons--cross]"
              style={{ width: "2rem", height: "2rem" }}
            ></span>
          </div>
          <div className="ml-[10.5rem] justify-start w-[161px] -mt-2">
            <p className="text-slate-300 opacity-75 text-[16px]">2 Accounts per service</p>
          </div>
          <div className="ml-[7rem] justify-start w-[120px] -mt-2">
            <p className="text-slate-300 opacity-75">5 Accounts per service</p>
          </div>
        </div>
        <div className="flex w-[1228px] h-[56px] ">
          <p className="px-5 w-[483px] justify-center items- text-[16px] ">File Import</p>
          <div className="px-14 mt-5 w-[161px]">
            <span
              className="icon-[system-uicons--cross]"
              style={{ width: "2rem", height: "2rem" }}
            ></span>
          </div>
          <div className="px-[10.5rem] mt-5 w-[161px]">
            <span
              className="icon-[ic--sharp-check]"
              style={{ width: "2rem", height: "2rem", color: "#306AFF" }}
            ></span>
          </div>
          <div className="ml-28 mt-5 w-[161px]">
            <span
              className="icon-[ic--sharp-check]"
              style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
            ></span>
          </div>
        </div>
        <div className="flex w-[1228px] h-[56px] bg-brand-slate">
          <p className="px-5 w-[483px] justify-center items- text-[16px] ">
            Advance options for all services
          </p>
          <div className="px-14 mt-5 w-[161px]">
            <span
              className="icon-[system-uicons--cross]"
              style={{ width: "2rem", height: "2rem" }}
            ></span>
          </div>
          <div className="px-[10.5rem] justify-center w-[161px]">
            <p className="text-slate-300 opacity-75">Limited</p>
          </div>
          <div className="ml-28 mt-5 w-[161px]">
            <span
              className="icon-[ic--sharp-check]"
              style={{ width: "2rem", height: "2rem", color: "#7551CB" }}
            ></span>
          </div>
        </div>
        <div className="flex w-[1228px] h-[56px]">
          <p className="px-5 w-[483px] justify-center items- text-[16px] "></p>
          <div className="px-14 mt-5 w-[161px]">
            {/* <Button className="" buttonPrimary={true} style={{ backgroundColor: "#25262D", boxShadow: "0 4px 0px 1px #FEFEFE", width: "161px", height: "38px", justifyContent: "center" }} alignSelf="center" to="/account">
                            Get Free
                        </Button> */}
            <TailwindButton
              buttonBGColor="bg-transparent"
              buttonHeight="h-[45px]"
              buttonWidth="w-[161px]"
              buttonBorderColor="border-white"
              buttonText="Get Free"
              buttonURL="/account"
              buttonTextTailwindStyle="font-bold"
            />
          </div>
          <div className="px-[10.5rem] mt-5 w-[161px]">
            <TailwindButton
              buttonBGColor="bg-[#306AFF]"
              buttonBorderColor="border-[#2D5ACC]"
              buttonHeight="h-[45px]"
              buttonWidth="w-[161px]"
              buttonText="Get Premium"
              buttonURL="/account"
              buttonTextTailwindStyle="font-bold"
            />
          </div>
          <div className="ml-28 mt-5">
            <TailwindButton
              buttonBGColor="bg-[#7551CB]"
              buttonBorderColor="border-[#422686]"
              buttonHeight="h-[45px]"
              buttonWidth="w-[161px]"
              buttonText="Get Ultimate"
              buttonURL="/account"
              buttonTextTailwindStyle="font-bold"
            />
          </div>
        </div>
        <div className="mt-10"></div>
      </div>
    </div>
  );
};

export default AdditionalFeatures;
